import { siteTokenFromHost } from "@/lib/api/config";

export const HISTORY_CAP = 200;
export const HISTORY_PAGE = 50;

export const MAX_BODY_LENGTH = 200;
export const RATE_WINDOW_SECONDS = 60;
export const RATE_MAX_PER_WINDOW = 20;
export const BURST_WINDOW_SECONDS = 10;
export const BURST_MAX_PER_WINDOW = 5;
export const DUPLICATE_WINDOW_SECONDS = 30;
export const TOKEN_WINDOW_SECONDS = 60;
export const TOKEN_MAX_PER_WINDOW = 30;

export const FEED_REFRESH_SECONDS = 30;
export const WIN_CARD_COOLDOWN_SECONDS = 60;
export const SYSTEM_NOTICE_SECONDS = 1800;

const trimmed = (value: string | undefined) => {
  const next = value?.trim();
  return next ? next : null;
};

export const chatConfig = {
  ablyKey: trimmed(process.env.ABLY_API_KEY),
  redisUrl: trimmed(process.env.UPSTASH_REDIS_REST_URL) ?? trimmed(process.env.KV_REST_API_URL),
  redisToken: trimmed(process.env.UPSTASH_REDIS_REST_TOKEN) ?? trimmed(process.env.KV_REST_API_TOKEN),
  moderatorIds: (process.env.CHAT_MODERATOR_IDS ?? "")
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean),
  highRollerTierIds: (process.env.CHAT_HIGH_ROLLER_TIER_IDS ?? "")
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean),
  isProduction: process.env.NODE_ENV === "production",
};

export const devIdentityAllowed = () => {
  if (process.env.CHAT_DEV_IDENTITY === "0") return false;
  if (!chatConfig.isProduction) return true;
  return process.env.CHAT_DEMO_IDENTITY === "1";
};

/* The site token is resolved by the shared API layer so chat and the rest of
   the app can never disagree about which site a request belongs to. Chat also
   uses it to namespace Redis keys and Ably channels, and an empty string there
   would collapse every site onto one channel, so it falls back to a literal. */
export const siteIdFromHost = (host: string | null) => siteTokenFromHost(host) || "local";

export const roomKey = (siteId: string, roomId: string) => `chat:${siteId}:${roomId}`;
